const MOBILE_UA_PATTERNS = [
  /Android/i,
  /webOS/i,
  /iPhone/i,
  /iPad/i,
  /iPod/i,
  /BlackBerry/i,
  /Windows Phone/i,
  /Mobile/i,
  /Tablet/i,
];

/**
 * 基于 User Agent 检测是否为移动设备
 */
export function isMobileByUA(): boolean {
  if (typeof window === 'undefined') return false;

  const userAgent = navigator.userAgent;
  return MOBILE_UA_PATTERNS.some((pattern) => pattern.test(userAgent));
}

/**
 * 基于 User Agent 检测是否为 iOS 设备
 */
export function isIOS(): boolean {
  if (typeof window === 'undefined') return false;

  const userAgent = navigator.userAgent;
  return userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod');
}
